import { render, staticRenderFns } from "./import-goods-detail-modal.vue?vue&type=template&id=3e85fd88&scoped=true"
import script from "./import-goods-detail-modal.vue?vue&type=script&lang=ts"
export * from "./import-goods-detail-modal.vue?vue&type=script&lang=ts"
import style0 from "./import-goods-detail-modal.vue?vue&type=style&index=0&id=3e85fd88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e85fd88",
  null
  
)

export default component.exports